import React from "react";
import { useForm } from "react-hook-form";
import axiosInstance from "../auth/axioInstance";
import { useAuth } from '../auth/Authcontext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";

export default function UploadCompetitionHorse() {


    const { register, handleSubmit , formState: { errors }} = useForm();
    const {contextValue} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const competetionid = queryParams.get("competetionid");


    const onSubmit = async (data) => {

        console.log(data)
        const formData = new FormData();
        formData.append("file", data.file[0]); 
        formData.append("CompetitionId", competetionid);
        contextValue.showLoader();
        contextValue.updateLoaderText("Uploaded file...");

        try {
            const res = await axiosInstance.post("/competition/bulk-upload-horses", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            console.log("Upload success:", res.data);
            toast.success("File uploaded successfully");
            navigate('/competition/'+competetionid);
        } catch (err) {

                        toast.error("Error uploading file, Please check file format");
            
            console.error("Upload failed:", err);
        }finally{
            contextValue.hideLoader();
        }
    };
    return (
        <div className='container h-100 overflow-auto' style={{ height: '100vh !important' }}>
            <form className='row' onSubmit={handleSubmit(onSubmit)}>

                <p className='lead'>Choose CSV file.</p>
                <div>
                    <input className='form-control mb-3' type="file" 
                            {...register("file", { required: "Please select a file" })}

                    />
                    {errors.file && (
                        <p style={{ color: "red", fontSize: "14px" }}>
                        {errors.file.message}
                        </p>
                    )}
                </div>
                <div className='col-auto'>
                    <button className='btn btn-success text-white me-2' type='submit' style={{ marginRight: '10px' }}>
                        Upload
                    </button>
                    <button className='btn btn-azure ml-4' type='button' onClick={() => navigate('/competition/'+competetionid)} >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    )
}